import {useQuery} from 'react-query';
import {request} from '../utils/axios-utils';

const fetchDefaultList = (type)=>{
    return request({url:`/defaults?type=${type.queryKey[0]},${'eshipboxes'}`, method:'GET'})
}

export const useGetDefaults = (onSuccess, type, select) => {
    return useQuery(type, fetchDefaultList,{
        onSuccess: onSuccess?onSuccess:null,
        select: select?(data) => select(data.data):(data)=>data.data
    });   
}


